import { Checkbox } from '@/components/ui/checkbox'
import { FormField } from '@/components/ui/form'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import FieldWrapper from './FieldWrapper'
import { useContext } from 'react'
import { FormEntityContext } from '../../config/context/forms'

interface Props {
  name: string
  customDescription?: string
  customLabel?: string
  layout?: 'box' | 'stacked' | 'inline'
}

const CheckboxField = ({
  name,
  customDescription,
  customLabel,
  layout = 'box',
}: Props) => {
  const { t } = useTranslation()
  const { control } = useFormContext()
  const { entityType, i18nPrefix } = useContext(FormEntityContext)

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <FieldWrapper
            className={
              layout === 'inline'
                ? 'inline-flex flex-row-reverse items-center gap-2 [&>label]:mt-2'
                : ''
            }
            layout={layout}
            label={
              customLabel ?? t(`${i18nPrefix}.${entityType}.${name}.label`)
            }
            description={
              customDescription ??
              t(`${i18nPrefix}.${entityType}.${name}.description`)
            }
          >
            <Checkbox checked={field.value} onCheckedChange={field.onChange} />
          </FieldWrapper>
        )
      }}
    />
  )
}

export default CheckboxField
